import React, { useState, useEffect } from 'react';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import '../../assets/styles/Freames.css';
import { oneKlicks } from '../../SDK/oneclick';
import ImageShow from '../../Uitiles/ImageShow';
import { useNavigate } from 'react-router-dom';
import { Badge, InputGroup, Form, Button } from 'react-bootstrap';

const Freames = () => {
  const navigate = useNavigate();
  const [frames, setFrames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedFrame, setSelectedFrame] = useState(null);
  const [uploadForm, setUploadForm] = useState({
    title: '',
    description: '',
    category: '',
    status: 'publish'
  });
  const [editForm, setEditForm] = useState({
    title: '',
    description: '',
    category: '',
    status: 'publish'
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [search, setSearch] = useState('');

  // Mock data for demonstration - replace with actual API calls
  const mockFrames = [
    {
      id: 1,
      title: 'Modern Frame Design',
      description: 'Contemporary frame with clean lines',
      category: 'Modern',
      status: 'publish',
      imageUrl: 'https://via.placeholder.com/300x200',
      createdAt: '2024-01-15',
      fileId: 'frame_001'
    },
    {
      id: 2,
      title: 'Classic Wooden Frame',
      description: 'Traditional wooden frame design',
      category: 'Classic',
      status: 'publish',
      imageUrl: 'https://via.placeholder.com/300x200',
      createdAt: '2024-01-10',
      fileId: 'frame_002'
    }
  ];

  useEffect(() => {
    loadFrames();
  }, []);

  const loadFrames = async () => {
    setLoading(true);
    try {
      const tableSchema = "";
      const tableName = "postframes";
      const conditions = {
        
      }
      const orderBy = "id DESC";
      const search = "";
      const pagination = {
        page: 1,
        limit: 10,
      }
      const margedata = "";
      const frames = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata)
      console.log("frames", frames.data);

      if (frames && frames.data) {
        setFrames(frames.data);
      } else {
        setFrames([]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error loading frames:', error);
      setFrames([]);
      setLoading(false);
    }
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'frames', // root folder
        "public",
        file
      );

      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedFile(file);
        setUploadForm(prev => ({ ...prev, imageUrl: `${upload.file.root}/${upload.file.fileName}` }));
        setUploadForm(prev => ({ ...prev, imageid: `${upload.fileId}` }));

      }
    }
  };

  const handleUpload = async () => {
    if (!selectedFile || !uploadForm.title.trim()) {
      alert('Please select a file and enter a title');
      return;
    }

    setUploading(true);
    try {
      const tableSchema = "";
      const tableName = "postframes";
      const data = {
        title: uploadForm.title,
        description: uploadForm.description,
        category: uploadForm.category,
        status: uploadForm.status,
        imageUrl: uploadForm.imageUrl,
        imageid: uploadForm.imageid,
        blowPrintUrl: uploadForm.blowPrintUrl,
        blowPrintid: uploadForm.blowPrintid,
      }
      const conditions = {}
      const uploadResult = await oneKlicks.create(tableSchema, tableName, data, conditions)

      if (uploadResult.error) {
        throw new Error(uploadResult.error);
      }

      // Refresh the frames list
      await loadFrames();
      setShowUploadModal(false);
      setUploadForm({ title: '', description: '', category: '', status: 'publish' });
      setSelectedFile(null);

      alert('Frame uploaded successfully!');
    } catch (error) {
      console.error('Upload error:', error);
      alert(`Upload failed: ${error.message}`);
    } finally {
      setUploading(false);
    }
  };

  const handleEditFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'frames', // root folder
        "public",
        file
      );

      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedFile(file);
        setEditForm(prev => ({ ...prev, imageUrl: `${upload.file.root}/${upload.file.fileName}` }));
        setEditForm(prev => ({ ...prev, imageid: `${upload.fileId}` }));

      }
    }
  };

  const handleBlowPrintFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'frames', // root folder
        "public",
        file
      );
      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedFile(file);
        setEditForm(prev => ({ ...prev, blowPrintUrl: `${upload.file.root}/${upload.file.fileName}` }));
        setEditForm(prev => ({ ...prev, blowPrintid: `${upload.fileId}` }));
      }
    }
  };

  const handleEditBlowPrintFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'frames', // root folder
        "public",
        file
      );
      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedFile(file);
        setEditForm(prev => ({ ...prev, blowPrintUrl: `${upload.file.root}/${upload.file.fileName}` }));
        setEditForm(prev => ({ ...prev, blowPrintid: `${upload.fileId}` }));
      }
    }
  };

  const handleupdate = async () => {
    console.log("editForm", editForm);
    const tableSchema = "";
    const tableName = "postframes";
    const data = {
      title: editForm.title,
      description: editForm.description,
      category: editForm.category,
      status: editForm.status,
      imageUrl: editForm.imageUrl,
      imageid: editForm.imageid,
      blowPrintUrl: editForm.blowPrintUrl,
      blowPrintid: editForm.blowPrintid,
    }
    const conditions = {
      id: selectedFrame.id,
    }
    const updateResult = await oneKlicks.update(tableSchema, tableName, data, conditions);
    if (updateResult.error) {
      throw new Error(updateResult.error);
    }

    // Refresh the frames list
    await loadFrames();
    setShowEditModal(false);
    setSelectedFrame(null);
    alert('Frame updated successfully!');
  }

  const handleDelete = async (frameId, imageId, blowPrintId) => {
    if (!window.confirm('Are you sure you want to delete this frame?')) {
      return;
    }

    try {
      // Delete files from OneKlicks if fileIds exist
      if (imageId) {
        await OneKlicksFileSDK.deleteFile(imageId);
      }
      if (blowPrintId) {
        await OneKlicksFileSDK.deleteFile(blowPrintId);
      }

      // Delete frame from database
      const tableSchema = "";
      const tableName = "postframes";
      const conditions = {
        id: frameId,
      }
      const deleteResult = await oneKlicks.delete(tableSchema, tableName, conditions);

      if (deleteResult.error) {
        throw new Error(deleteResult.error);
      }

      // Refresh the frames list
      await loadFrames();
      alert('Frame deleted successfully!');
    } catch (error) {
      console.error('Delete error:', error);
      alert(`Delete failed: ${error.message}`);
    }
  };

  const openEditModal = (frame) => {
    setSelectedFrame(frame);
    setEditForm({
      title: frame.title,
      description: frame.description,
      category: frame.category,
      status: frame.status,
      imageUrl: frame.imageUrl,
      imageid: frame.imageid,
      blowPrintUrl: frame.blowPrintUrl,
      blowPrintid: frame.blowPrintid
    });
    setShowEditModal(true);
  };

  const filteredFrames = frames.filter(frame => {
    const matchesSearch = frame.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      frame.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'all' || frame.category === filterCategory;
    return matchesSearch && matchesCategory;
  });

  const categories = ['all', 'Modern', 'Classic', 'Vintage', 'Minimalist', 'Luxury'];

  const openAdd = () => {
    navigate('/admin/frame-editor');
  };

  if (loading) {
    return (
      <div className="frames-container">
        <div className="loading-spinner">Loading frames...</div>
      </div>
    );
  }

  return (
    <div className="frames-container">
    {/* Page Header */}
      <div className="dc-haslayout dc-dbsectionspace">
        <div className="container-fluid py-3">
          <div className="card mb-5">
            <div className="card-body">
              <div className="align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2  mb-2">
                  <h5 className="mb-0 font-weight-bold mr-3">Frames Management</h5>
                  <Badge bg="info">Post / Fliver / Instagram</Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                  <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                    <Form.Control
                      placeholder="Search..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </InputGroup>
                  <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                    <Button variant="primary" style={{ height: 50, width: 150 }} onClick={openAdd}>+ Add Frame</Button>
                    <Button variant="primary" style={{ height: 50 }} onClick={() => window.open("/superadmin/png-to-template-converter", "_blank")}>Convert PNG to Template</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <div className="frames-grid">
                  {filteredFrames.length === 0 ? (
                    <div className="no-frames">
                      <p>No frames found. Upload your first frame!</p>
                    </div>
                  ) : (
                    filteredFrames.map(frame => (
                      <div key={frame.id} className="frame-card">
                        <div className="frame-image">
                          <ImageShow url={frame.imageUrl} />
                          <div className="frame-overlay">
                            <button
                              className="btn-edit"
                              onClick={() => navigate(`/admin/frame-editor?id=${frame.frameid}`)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn-delete"
                              onClick={() => handleDelete(frame.id, frame.imageid, frame.blowPrintid)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                        <div className="frame-info">
                          <h3>{frame.title}</h3>
                          <p>{frame.description}</p>
                          <div className="frame-meta">
                            <span className="category">{frame.category}</span>
                            <span className="status">{frame.status}</span>
                            <span className="date">{frame.created_at ? frame.created_at.split('T')[0] : 'N/A'}</span>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Upload Modal */}
      {showUploadModal && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-header">
                <h2>Upload New Frame</h2>
                <button
                  className="btn-close"
                  onClick={() => setShowUploadModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Title *</label>
                  <input
                    type="text"
                    value={uploadForm.title}
                    onChange={(e) => setUploadForm(prev => ({ ...prev, title: e.target.value }))}
                    placeholder="Enter frame title"
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={uploadForm.description}
                    onChange={(e) => setUploadForm(prev => ({ ...prev, description: e.target.value }))}
                    placeholder="Enter frame description"
                    rows="3"
                  />
                </div>
                <div className="form-group">
                  <label>Category</label>
                  <select
                    value={uploadForm.category}
                    onChange={(e) => setUploadForm(prev => ({ ...prev, category: e.target.value }))}
                  >
                    <option value="">Select category</option>
                    {categories.filter(cat => cat !== 'all').map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select
                    value={uploadForm.status}
                    onChange={(e) => setUploadForm(prev => ({ ...prev, status: e.target.value }))}
                  >
                    <option value="publish">Publish</option>
                    <option value="draft">Draft</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Frame blow print *</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleBlowPrintFileSelect}
                  />
                  {selectedFile && (
                    <p className="file-info">Selected: {selectedFile.name}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>Frame Image *</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileSelect}
                  />
                  {selectedFile && (
                    <p className="file-info">Selected: {selectedFile.name}</p>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn-cancel"
                  onClick={() => setShowUploadModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn-upload"
                  onClick={handleUpload}
                  disabled={uploading}
                >
                  {uploading ? 'Uploading...' : 'Upload Frame'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {showEditModal && selectedFrame && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-header">
                <h2>Edit Frame</h2>
                <button
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Title *</label>
                  <input
                    type="text"
                    value={editForm.title}
                    onChange={(e) => setEditForm(prev => ({ ...prev, title: e.target.value }))}
                    placeholder="Enter frame title"
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={editForm.description}
                    onChange={(e) => setEditForm(prev => ({ ...prev, description: e.target.value }))}
                    placeholder="Enter frame description"
                    rows="3"
                  />
                </div>
                <div className="form-group">
                  <label>Category</label>
                  <select
                    value={editForm.category}
                    onChange={(e) => setEditForm(prev => ({ ...prev, category: e.target.value }))}
                  >
                    <option value="">Select category</option>
                    {categories.filter(cat => cat !== 'all').map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select
                    value={editForm.status}
                    onChange={(e) => setEditForm(prev => ({ ...prev, status: e.target.value }))}
                  >
                    <option value="publish">Publish</option>
                    <option value="draft">Draft</option>
                  </select>
                </div>
              </div>
              <div className="modal-body">
                <ImageShow url={editForm.blowPrintUrl} />
                <div className="form-group">
                  <label>Frame blow print *</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleEditBlowPrintFileSelect}
                  />
                </div>
              </div>
              <div className="modal-body">
                <ImageShow url={editForm.imageUrl} />
                <div className="form-group">
                  <label>Frame Image *</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleEditFileSelect}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn-cancel"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn-save"
                  onClick={handleupdate}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default Freames;
